import React, { useEffect, useState } from "react";
import StockChart from "./StockChart";
import styled, { isStyledComponent } from "styled-components";
import axios from "axios";
import "../App.css";
const ContentContainer = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
`;

const Header = styled.div`
  background-color: black;
  color: green;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 20px;
  font-family: 'Share Tech Mono', 'Courier New', monospace;
  text-shadow: 0px 0px 5px green;
`;

const Header2 = styled.div`
  background-color: black;
  color: green;
  padding: 8px 12px;
  border-radius: 4px;
  text-align: center;
  margin-bottom: 16px;
  font-family: 'Share Tech Mono', monospace;
  text-shadow: 0px 0px 3px green;
  font-size: 1.2em;
`;



const ScrollableCard = styled.div`
  background: black;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 0 15px green;
  width: 400px;
  height: 500px;
  overflow-y: auto;
  transition: all 0.3s ease-in-out;
  color: green;
  font-size: 1.1em;
  font-family: 'Share Tech Mono', 'Courier New', monospace;
  text-shadow: 0px 0px 5px green;
  margin-bottom: 30px;
  margin: 40px;
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 0 25px limegreen;
  }
`;
const AdviceCard = styled.div`
  background: black;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 0 15px green;
  width: 1275px;
  height: 500px;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  transition: all 0.3s ease-in-out;
  color: green;
  font-size: 1.1em;
  font-family: 'Share Tech Mono', 'Courier New', monospace;
  text-shadow: 0px 0px 5px green;
  margin: 0 auto; /* Centers the div horizontally */
  margin-bottom: 50px;
  position: relative;
  right: -30px;
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 0 25px limegreen;
  }
`;


const Select = styled.select`
  padding: 10px;
  width: 200px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: 0.3s;
  background: white;
  
  &:focus {
    border-color: #4a90e2;
    outline: none;
    box-shadow: 0 0 5px rgba(74, 144, 226, 0.5);
  }
`;

const ChartContainer = styled.div`
  width: 100%;
  max-width: 800px;
  background: #222;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 15px green;
  /*animation: fadeIn 0.5s ease-in-out;*/
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 0 25px limegreen;
  }
`;
const StockContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: #111;
  border-radius: 12px;
  box-shadow: 0 0 15px green;
`;

const Content = () => {
  const baseURLNews = "https://jamestan-bmake2025-b-89.deno.dev/news?n=";
  const baseURLLaws = "https://jamestan-bmake2025-b-89.deno.dev/laws?n=";
  const baseURLStocks = "https://jamestan-bmake2025-b-89.deno.dev/stocks";
  const baseURLAdvice = "https://jamestan-bmake2025-b-89.deno.dev/advice";
  const baseURLHoldings = "https://jamestan-bmake2025-b-89.deno.dev/holdings";
  const [news, setNews] = useState([]);
  const [laws, setLaws] = useState([]);
  const [stocks, setStocks] = useState([])
  const [stock, setStock] = useState(undefined);
  const [stockData, setStockData] = useState([])
  const [advice, setAdvice] = useState([])
  const [holdings, setHoldings] = useState([])
  
  useEffect(() => {
    axios.get(baseURLNews).then((response) => {
      setNews(response.data);
    });
    axios.get(baseURLLaws).then((response) => {
        setLaws(response.data)
    });
    axios.get(baseURLAdvice).then((response) => {
        
        let lines = String(response.data[0].advice).split("<br>");
        setAdvice(lines)
        console.log(lines);
        console.log(advice);
        
        
    });
    axios.get(baseURLStocks).then((response) => {
      setStocks(response.data);
      setStock(response.data[0]);
    });
    axios.get(baseURLHoldings).then((response) => {
      setHoldings(response.data);

    });
    

    
  }, []);

    async function pullHoldings() {
      axios.get(baseURLHoldings).then((response) => {
        setHoldings(response.data);
    });}

    


  useEffect(() => {
    axios.post(baseURLStocks, { ticker: stock }).then((response) => {
      if (stock == null) return;
      setStockData(response.data);
      console.log(response.data);
    });
  }, [stock]);

  const addToHoldings = (e) => {
   
    axios.post(baseURLHoldings, {ticker: e}).then((response) => {
      pullHoldings();
    }

  );
  
  }

  return (
    <ContentContainer>
      <div>
        <Header>
          <h1>Sentiment Analysis Tool</h1>
        </Header>
        
          <h2>finsense-alphaLLM's advice</h2>
        
        <AdviceCard>
            <p>
            <div>
              {advice.map((line, index) => (
                  <p key={index}>{line}</p>
                        ))}
        </div>
            </p>
          <audio controls>
            <source src={process.env.PUBLIC_URL + '/sonic.mp3'} type="audio/mp3"/>
          </audio>
            
        </AdviceCard>
        <h2>YOUR STOCK HOLDINGS AND MARKET DATA </h2>
        <div className="rows">
        
       
        <ScrollableCard>
            
            
          {holdings.length > 0 ? (
            <ul>
              {holdings.map((item, index) => (
                <li key={index}>
                  <strong>{item.ticker}</strong>
                  <button onClick={() => addToHoldings(item.ticker)}> RESET </button>
                  <p>{item.count}</p>
                </li>
              ))}
            </ul>
          ) : (
            <p>Loading...</p>
          )}
        </ScrollableCard>
        <StockContainer>
          <Select onChange={(e) => setStock(e.target.value)}>
            {(stocks.length > 0) && stocks.map(s => <option key={s} value={s}>{s}</option>)}
          </Select>
          <ChartContainer>
            <StockChart data={stockData}/>
          </ChartContainer>
        </StockContainer>
        </div>
        
        <h2>LATEST NEWS AND LEGISLATION</h2>
        <div className="rows">
      
        <ScrollableCard>
          
          {news.length > 0 ? (
            <ul>
              {news.map((item, index) => (
                <li key={index}>
                  <strong>{item.title}</strong>
                  <p>{item.description}</p>
                </li>
              ))}
            </ul>
          ) : (
            <p>Loading...</p>
          )}
        </ScrollableCard>
        <ScrollableCard>
          {laws.length > 0 ? (
            <ul>
              {laws.map((item, index) => (
                <li key={index}>
                  <strong>{item.number}</strong>
                  <p>{item.title}</p>
                </li>
              ))}
            </ul>
          ) : (
            <p>Loading...</p>
          )}
        </ScrollableCard>
        </div>
      </div>
    </ContentContainer>
  );
};

export default Content;
